const {
  NODE_ENV,
  REACT_APP_VIDEO_URL,
  REACT_APP_CREATE_VG_URL,
  REACT_APP_PROJECT,
} = process.env;

const parentDomain = '.vive.com';
export const IS_DEV = NODE_ENV === 'development';

export const COOKIE_OPTIONS = {
  path: '/',
  domain: IS_DEV ? 'localhost' : parentDomain,
};

export const PROJECT = REACT_APP_PROJECT;

export const SUPPORTED_LNGS = ['en'];
export const SUPPORTED_LNGS_NAME = {
  'tw': '繁體中文',
  'cn': '简体中文',
  'en': 'English',
  'jp': '日本語',
  'ko': '한국인',
  'de': 'Deutsch',
  'fr': 'Français',
  'ru': 'Pусский'
};

export const SUPPORTED_LNGS_ALIAS = {
  'tw': ['tw'],
  'cn': ['cn'],
  'en': ['en'],
  'jp': ['jp', 'ja'],
  'ko': ['ko'],
  'de': ['de'],
  'fr': ['fr'],
  'ru': ['ru'],
};

export const VIDEO_URL = REACT_APP_VIDEO_URL;

export const BUTTON_URL = {
  vg: REACT_APP_CREATE_VG_URL,
  vbt: 'https://business.vive.com/us/solutions/training/'
}

export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.vivemedialab.ccsvg';